import { Paths } from './paths/paths';
import { apiSlice } from './apiSlice';
import {
  NomineeInvestment,
  NomineeInvestmentAttribution,
} from './response/NomineeInvestment';
import {
  NewNomineeInvestmentAttribution,
  NomineeInvestmentAttributionList,
  UpdateNomineeInvestmentAttribution,
} from './request/NomineeInvestmentAttribution';

export const nomineeInvestmentsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    investments: builder.query<NomineeInvestment[], void>({
      query: () => Paths.NomineeInvestment,
    }),
    investmentAttributions: builder.query<
      NomineeInvestmentAttribution[],
      NomineeInvestmentAttributionList
    >({
      query: (data) => ({
        url: Paths.NomineeInvestmentAttribution,
        method: 'GET',
        params: data,
      }),
    }),
    createInvestmentAttribution: builder.mutation<
      NomineeInvestmentAttribution,
      NewNomineeInvestmentAttribution
    >({
      query: (data) => ({
        url: Paths.NomineeInvestmentAttribution,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['nominee_investment_attributions'],
    }),
    updateInvestmentAttribution: builder.mutation<
      NomineeInvestmentAttribution,
      UpdateNomineeInvestmentAttribution
    >({
      query: (data) => ({
        url: Paths.NomineeInvestmentAttribution,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['nominee_investment_attributions'],
    }),
    deleteInvestmentAttribution: builder.mutation<
      void,
      { investmentAttributionId: number }
    >({
      query: (data) => ({
        url: Paths.NomineeCustomer,
        method: 'DELETE',
        params: data,
      }),
      invalidatesTags: ['nominee_investment_attributions'],
    }),
  }),
});

export const {
  useInvestmentsQuery,
  useInvestmentAttributionsQuery,
  useCreateInvestmentAttributionMutation,
  useUpdateInvestmentAttributionMutation,
  useDeleteInvestmentAttributionMutation,
} = nomineeInvestmentsSlice;
